import { render, staticRenderFns } from "./BillingTrackerAnnouncement.vue?vue&type=template&id=2707dc6c&scoped=true&"
import script from "./BillingTrackerAnnouncement.vue?vue&type=script&lang=js&"
export * from "./BillingTrackerAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./BillingTrackerAnnouncement.scss?vue&type=style&index=0&id=2707dc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.6_@vue+compiler-sfc@3.5.11_babel-core@7.0.0-bridge.0_@babel+core@7.17.9_f17ab4d8c27c5d7082708fbbc2f82c9d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707dc6c",
  null
  
)

export default component.exports